import { render } from "./Navbar.vue?vue&type=template&id=1c5ba2f3"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=1c5ba2f3&lang=css"

import exportComponent from "C:\\Users\\Norbert\\webdev\\udemy-vue3\\chat\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__